import React, { useRef } from "react";
import styles from "./HorseServicesTab.module.css";
import i18n from "../../Services/i18n";
import { useToasts } from "../../LayoutComponents/ToastContext";
import { useModal } from "../../Context/ModalContext";
import { usePrivileges } from "../../Context/PrivilegeContext";
import ListCardContainer from "../ListCard/ListCardContainer";
import UpsertServiceOccurenceModal from "../Modal/UpsertServiceOccurenceModal";
import PrivilegeValidationService from "../../Services/privilegeValidationService";

const HorseServicesTab = ({ horse, reloadDetailHorse }) => {
  const serviceListRef = useRef({});

  const { addToast } = useToasts();
  const { openModal } = useModal();
  const serviceModalRef = useRef(null);
  const { privileges } = usePrivileges();

  const handleAddServiceClick = async () => {
    if (horse.services.length === 0) {
      addToast(
        i18n.t("BoardServiceClient.ServiceOccurenceNoService"),
        "SERVICEOCCURENCENOSERVICE",
        "WARNING",
        true,
      );
      return;
    }

    if (!PrivilegeValidationService.HorseCanAddService(await privileges(), horse.services.length)) {
      addToast(
        i18n.t("Privilege.ValidationError.MaxServicesByHorse"),
        "PrivilegeValidationFailed",
        "ERROR",
        true,
      );
      return;
    }

    openModal({
      title: i18n.t("BoardServiceClient.ServiceOccurenceCreate"),
      form: "formServiceOccurence",
      wideMode: true,
      hideSaveButton: false,
      hideSaveAndCloseButton: false,
      hideGenerateReportButton: false,
      generateReportLabel: i18n.t("Modal.GenerateReport.ServiceReport"),
      canClose: async () => {
        const isDirty = serviceModalRef.current?.isDirty?.();
        if (!isDirty) return true;

        return window.confirm(i18n.t("Modal.UnsavedChangesConfirm"));
      },
      onSave: async () => {
        const isValid = await serviceModalRef.current.validate();
        if (!isValid) return;
        return await serviceModalRef.current.save();
      },
      onClose: () => {},
      content: (
        <UpsertServiceOccurenceModal
          ref={serviceModalRef}
          client={{
            externalId: horse.clientExternalId,
            cardName: horse.clientName,
          }}
          horse={horse}
          onSave={() => reloadDetailHorse(horse, true)}
        />
      ),
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.services}>
        <ListCardContainer
          hideHeader={true}
          addButtonAction={handleAddServiceClick}
          isLoading={false}
          hideEmptyHorseCard={true}
          refresh={() => reloadDetailHorse(horse, true)}
          dataItems={horse?.serviceOccurences ?? []}
          onSelect={() => {}}
          selectedItemExternalId={horse.externalId}
          type="serviceoccurence"
          ref={serviceListRef}
          storageId={"HorseServiceTab.Service"}
        />
      </div>
    </div>
  );
};

export default HorseServicesTab;
